import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SPACING } from "../../common/constants/spacing";
import { useTheme } from "../../common/contexts/ThemeContext";

export const MissingAssetsPlaceholder = () => {
  const { t } = useTranslation("assets");
  const { colors } = useTheme();
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: SPACING.xl,
        width: "100%",
        borderRadius: "6px",
        border: "1px dashed" + colors.border.secondary,
      }}
    >
      <Typography
        variant="h2"
        sx={{
          color: "text.secondary",
          mb: SPACING.md,
        }}
      >
        {t("noAssets")}
      </Typography>

      <Typography
        variant="bodyMd"
        sx={{
          color: "text.secondary",
          maxWidth: "500px",
          lineHeight: 1.6,
        }}
      >
        {t("noAssetsDescription")}
      </Typography>
    </div>
  );
};
